import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ArrowForward, VFlex, VTextButton } from '@/package';
import { useAuthStore, useTenantStore } from '@/store';
import type { Tenant } from '@/type';

import TenantItem from './TenantItem';

const TenantSelection = () => {
  const { tenantList, fetchTenantList, selectTenant } = useTenantStore();
  const { user, isTenantAuthenticated, signOut } = useAuthStore();
  const { t } = useTranslation();
  const isInitialized = !!tenantList.length;

  const onTenantItemClick = (tenantId: Tenant['tenantID']) => {
    selectTenant(tenantId);
  };

  useEffect(() => {
    if (isInitialized) return;

    fetchTenantList();
  }, []);

  useEffect(() => {
    if (!isTenantAuthenticated() && tenantList.length === 1) {
      onTenantItemClick(tenantList[0].tenantID);
    }
  }, [tenantList, user]);

  return (
    <VFlex direction="col" gap={1.5} className="pt-6">
      <VFlex direction="col" gap={0.5} className="w-[296px]">
        {tenantList
          .filter(tenant => !tenant.delegation)
          .map(tenant => (
            <TenantItem
              key={tenant.tenantID}
              {...tenant}
              onClick={() => onTenantItemClick(tenant.tenantID)}
              Icon={ArrowForward}
            />
          ))}
        {!tenantList.length && (
          <VTextButton type="button" onClick={fetchTenantList}>
            Refresh tenant info
          </VTextButton>
        )}
      </VFlex>

      <VFlex className="py-1" direction="col" items="center" gap={0.25}>
        <span>{t('tenant.cantSeeMyWorkspace.intervallic')}</span>
        <strong className="cursor-pointer" onClick={signOut}>
          Try a different email
        </strong>
      </VFlex>
    </VFlex>
  );
};

export default TenantSelection;
